<template>
  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" origin="top right" offset-y bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="primary" class="mr-n3" outlined small>
        <span class="caption">Filtros</span>
        <v-icon right small>mdi-filter-outline</v-icon>
      </v-btn>
    </template>
    <v-list class="mw-350 pt-4">
      <v-list-item class="mb-4">
        <FilterDates
          :fetchData="fetchTransfers"
          :dateRange="true"
          :label="$t('transfer.filter.date')"
        />
      </v-list-item>
      <v-list-item>
        <FilterAutocomplete
          :label="$t('transfer.filter.status')"
          :fetchData="fetchTransfers"
          :items="status"
          :multiple="true"
          class="mb-n2"
          type="status"
        />
      </v-list-item>
      <v-list-item>
        <FilterSearch
          searchTerm="appointmentCode"
          :fetchData="fetchTransfers"
          label="appointmentCode"
          class="mb-n2"
        />
      </v-list-item>
      <v-list-item>
        <FilterSearch
          :fetchData="fetchTransfers"
          searchTerm="total"
          label="totalValue"
          type="number"
          class="mb-n2"
        />
      </v-list-item>
      <v-list-item>
        <FilterAutocomplete
          :label="$t('transfer.filter.orderBy')"
          :fetchData="fetchTransfers"
          :items="orderBy"
          type="orderBy"
          class="mb-n2"
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex'

import FilterDates from '@/components/filters/FilterDates'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import FilterSearch from '@/components/filters/FilterSearch'

export default {
  name: 'TransferListFilters',

  components: {
    FilterDates,
    FilterAutocomplete,
    FilterSearch,
  },

  methods: {
    ...mapActions([
      'fetchTransfers',
      'fetchHostsBySearchText',
      'searchVendors',
      'fetchPartners',
    ]),
  },

  data() {
    return {
      menu: false,

      status: [
        { value: 'CANCELED', name: this.$t('transfer.transferStatus.CANCELED') },
        { value: 'FAILED', name: this.$t('transfer.transferStatus.FAILED') },
        { value: 'PENDING', name: this.$t('transfer.transferStatus.PENDING') },
        { value: 'PROCESSING', name: this.$t('transfer.transferStatus.PROCESSING') },
        { value: 'COMPLETED', name: this.$t('transfer.transferStatus.COMPLETED') },
        // { value: 'DETACHED', name: this.$t('transfer.transferStatus.DETACHED') },
      ],

      orderBy: [
        { value: 'ASC', name: this.$t('transfer.orderBy.ASC') },
        { value: 'DESC', name: this.$t('transfer.orderBy.DESC') },
      ],
    }
  }
}
</script>
